import { isSupabaseConfigured } from "@/lib/env";
import { supabase } from "@/lib/supabase";
import { resolveStoredAssetRef } from "@/features/image-generation";

export const ENTITY_IMAGES_BUCKET = "entity-images";

function ensureConfigured() {
  if (!isSupabaseConfigured()) {
    throw new Error("Supabase environment variables are not configured.");
  }
}

export function buildEntityImagePath(userId: string, projectId: string, entityCardId: string) {
  return `${userId}/${projectId}/${entityCardId}`;
}

export async function uploadEntityImage(
  userId: string,
  projectId: string,
  entityCardId: string,
  file: File,
) {
  ensureConfigured();
  const path = buildEntityImagePath(userId, projectId, entityCardId);

  const { data, error } = await supabase.storage.from(ENTITY_IMAGES_BUCKET).upload(path, file, {
    cacheControl: "3600",
    contentType: file.type || undefined,
    upsert: true,
  });

  if (error) {
    throw error;
  }

  return data.path;
}

export async function deleteEntityImage(path: string) {
  ensureConfigured();
  const resolved = resolveStoredAssetRef(path, ENTITY_IMAGES_BUCKET);

  if (!resolved) {
    return;
  }

  const { error } = await supabase.storage
    .from(resolved.bucket)
    .remove([resolved.path]);

  if (error) {
    throw error;
  }
}

export async function createEntityImageSignedUrl(path: string) {
  ensureConfigured();
  const resolved = resolveStoredAssetRef(path, ENTITY_IMAGES_BUCKET);

  if (!resolved) {
    throw new Error("Entity image path is missing.");
  }

  const { data, error } = await supabase.storage
    .from(resolved.bucket)
    .createSignedUrl(resolved.path, 60 * 30);

  if (error) {
    throw error;
  }

  return data.signedUrl;
}
